module.exports = __webpack_public_path__ + "img/search-normal.324c2b0c.svg";